import { ApiError, getErrorMessage } from '@/lib/errors';

export function getPortfolioActionError(err: unknown): string {
  if (
    err instanceof ApiError &&
    (err.statusCode === 400 || err.statusCode === 409)
  ) {
    return err.message;
  }
  return getErrorMessage(err);
}

export function getSnowflakeActionError(err: unknown): string {
  if (err instanceof ApiError && err.statusCode === 400) {
    return "We couldn't complete that request. Check the details and try again.";
  }
  if (err instanceof ApiError && err.statusCode === 409) {
    return 'That was already updated. Refresh and try again.';
  }
  return getErrorMessage(err);
}
